<template>
  <div class="py-6 px-4 pb-24 space-y-6" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-6">
      
      <!-- Header -->
      <div class="bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-6 text-white">
        <h1 class="text-2xl font-bold mb-2">آدرس مشتری</h1>
        <p class="text-teal-100 text-sm">آدرس محل ارائه سرویس را وارد کنید</p>
      </div>

   

      <!-- Address Form Card -->
      <div class="bg-white rounded-lg border border-gray-200 p-6 space-y-4">
        <!-- Address Select -->
        <div>
          <label class="block text-sm font-bold text-gray-700 mb-2">{{$t('pleaseSelect')}}</label>
          <div class="relative">
            <select 
              style="border: 1px solid rgb(209, 213, 219) !important;"
              :items="address_items"
              v-model="selected_address"
              class="w-full px-4 pr-10 py-3 border border-gray-400 rounded-lg text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 appearance-none bg-white"
            >
              <option value="0">انتخاب کنید</option>
              <option 
                v-for="address in address_items" 
                :key="address.value" 
                :value="address.value"
              >
                {{address.label}}
              </option>
            </select>
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
              <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
          
          <!-- Display formatted address -->
          <div v-if="selected_address != 0 && formattedAddress" class="mt-3 bg-blue-50 border border-blue-200 rounded-lg p-3">
            <p class="text-xs text-gray-600 mb-1">آدرس انتخاب شده:</p>
            <p class="font-medium text-gray-900">{{ formattedAddress }}</p>
          </div>
        </div>

        <!-- Province and City Selects (shown when address is selected) -->
        <div v-if="selected_address != 0" class="space-y-4">
          <!-- Province -->
         <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-bold text-gray-700 mb-2">استان</label>
            <div class="relative">
              <select 
              style="border: 1px solid rgb(209, 213, 219) !important;"
                :items="province_items"
                v-model="selected_province"
                class="w-full px-4 pr-10 py-3 border border-gray-400 rounded-lg text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 appearance-none bg-white"
              >
                <option value="0">انتخاب استان</option>
                <option 
                  v-for="province in province_items" 
                  :key="province.value" 
                  :value="province.value"
                >
                  {{province.label}}
                </option>
              </select>
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>
           <!-- City -->
           <div>
            <label class="block text-sm font-bold text-gray-700 mb-2">شهر</label>
            <div class="relative">
              <select 
              style="border: 1px solid rgb(209, 213, 219) !important;"
                :items="city_items"
                v-model="selected_city"
                class="w-full px-4 pr-10 py-3 border border-gray-400 rounded-lg text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 appearance-none bg-white"
              >
                <option value="0">انتخاب شهر</option>
                <option 
                  v-for="city in city_items" 
                  :key="city.value" 
                  :value="city.value"
                >
                  {{city.label}}
                </option>
              </select>
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>
          </div> 

         

          <!-- Area -->
          <div v-if="area_items.length > 1">
            <label class="block text-sm font-bold text-gray-700 mb-2">منطقه</label>
            <div class="relative" v-click-outside="closeAreaDropdown">
              <!-- Selected Area Display / Search Input -->
              <div 
                @click="toggleAreaDropdown"
                class="w-full px-4 pr-10 py-3 border border-gray-400 rounded-lg text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 bg-white cursor-pointer flex items-center justify-between"
              >
                <span v-if="selected_area == 0" class="text-gray-500">انتخاب منطقه</span>
                <span v-else>{{ getSelectedAreaLabel() }}</span>
                <svg 
                  class="w-5 h-5 text-gray-500 transition-transform" 
                  :class="{ 'rotate-180': show_area_dropdown }"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              
              <!-- Dropdown Menu -->
              <div 
                v-if="show_area_dropdown"
                class="absolute z-50 w-full mt-2 bg-white border border-gray-300 rounded-lg shadow-xl max-h-64 overflow-hidden"
              >
                <!-- Search Input -->
                <div class="p-3 border-b border-gray-200">
                  <div class="relative">
                    <input
                      v-model="area_search_text"
                      @input="filterAreaItems"
                      type="text"
                      placeholder="جستجوی منطقه..."
                      class="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 text-sm"
                      @click.stop
                    />
                    <svg 
                      class="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                </div>
                
                <!-- Options List -->
                <div class="overflow-y-auto max-h-48">
                  <div
                    @click="selectArea(0)"
                    :class="{ 'bg-teal-50 text-teal-700': selected_area == 0 }"
                    class="px-4 py-2 hover:bg-gray-50 cursor-pointer text-sm"
                  >
                    انتخاب منطقه
                  </div>
                  <div
                    v-for="area in filtered_area_items"
                    :key="area.value"
                    @click="selectArea(area.value)"
                    :class="{ 'bg-teal-50 text-teal-700': selected_area == area.value }"
                    class="px-4 py-2 hover:bg-gray-50 cursor-pointer text-sm"
                  >
                    {{ area.label }}
                  </div>
                  <div 
                    v-if="filtered_area_items.length === 0"
                    class="px-4 py-3 text-center text-gray-500 text-sm"
                  >
                    منطقه‌ای یافت نشد
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Location on Map Button -->
          <button 
            v-on:click="open_map"
            class="w-full bg-gradient-to-r from-teal-500 to-teal-600 text-white py-3 px-6 rounded-lg font-bold hover:shadow-lg transform hover:scale-102 transition-all"
          >
            {{$t('locationOnMap')}}
          </button>

          <!-- Address Textarea -->
          <div>
            <label class="block text-sm font-bold text-gray-700 mb-2">{{$t('address')}}</label>
            <textarea 
            style="border: 1px solid rgb(209, 213, 219) !important;"
              v-model="customer_address"
              rows="4"
              class="w-full px-4 py-3 border border-gray-400 rounded-lg text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 resize-none"
            ></textarea>
          </div>

          <!-- Save Address Button -->
          <button 
            v-if="selected_address != 0"
            v-on:click="save()"
            class="w-full bg-gradient-to-r from-teal-600 to-teal-700 text-white py-4 px-6 rounded-xl font-bold hover:shadow-xl transform hover:scale-102 transition-all"
          >
            {{$t('addAddress')}}
          </button>
        </div>
      </div>

    </div>

    <!-- Map Modal - Full Screen -->
    <transition name="modal">
      <div v-if="dialog_location" class="fixed inset-0 z-999 bg-white" style="margin: 0 !important;">
        <!-- Compact Toolbar -->
        <div class="px-4 py-3 border-b border-gray-200 flex items-center justify-between bg-white ">
          <button
            @click="dialog_location = false"
            class="w-10 h-10  items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
          >
            <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <h2 class="text-lg font-bold text-gray-900 flex-1 text-center">{{$t('locationOnMap')}}</h2>
          <button
            @click="dialog_location=false"
            class="px-5 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 font-medium transition-colors text-sm"
          >
            {{$t('save')}}
          </button>
        </div>
        
        <!-- Map Container - Takes remaining space -->
        <div class="h-screen-100 relative overflow-hidden w-full">
          <div ref="map" id="map2" class="basemap w-full h-full"></div>
          
          <!-- Current Location Button -->
          <button
            @click="getCurrentLocation"
            class="absolute bottom-8 left-4 z-10 w-12 h-12 bg-teal-500 shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors border border-gray-200"
            title="موقعیت فعلی"
          >
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </button>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import { bus } from '../../main'
  import mapboxgl from 'mapbox-gl'
  import Vue from 'vue'

  // Click outside directive
  Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
        if (!(el == event.target || el.contains(event.target))) {
          if (binding.expression && typeof vnode.context[binding.expression] === 'function') {
            vnode.context[binding.expression](event)
          }
        }
      }
      // Use setTimeout to avoid immediate trigger
      setTimeout(() => {
        document.body.addEventListener('click', el.clickOutsideEvent)
      }, 100)
    },
    unbind: function (el) {
      if (el.clickOutsideEvent) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  })

  export default {
    name: 'Attachments',
    data () {
      return {
        accessToken: 'pk.eyJ1Ijoiem9vZGtvbWFrIiwiYSI6ImNrOG1vYzVocjAxNm4zbWx2Zmk0bmJ1cHUifQ.rHAeQHubqjcMQTY2eQS1nA',
        user_addresses: [],
        phone_code_items: [],
        selected_phone_code: 1,

        province_items: [],
        selected_province: 0,

        city_items: [],
        selected_city: 0,
request_data:{},
        area_items: [],
        filtered_area_items: [],
        selected_area: 0,
        show_area_dropdown: false,
        area_search_text: '',

        selected_address: 0,
        customer_address: '',
        customer_phone: '',
        address_items: [],
        dialog_location: false,
        map: null,
        marker: null,
        user_location_lat: 0,
        user_location_lng: 0,
        addressInfo:null,
      }
    },
    computed: {
      formattedAddress() {
        if (this.selected_address == 0) return ''
        
        const province = this.province_items.find(p => p.value == this.selected_province)
        const city = this.city_items.find(c => c.value == this.selected_city)
        
        const parts = []
        
        if (province && province.label) {
          parts.push(province.label)
        }
        
        if (city && city.label) {
          parts.push(city.label)
        }
        
        if (this.customer_address && this.customer_address.trim()) {
          parts.push(this.customer_address)
        }
        
        return parts.length > 0 ? parts.join('، ') : ''
      }
    },
    mounted () {
      this.get_phone_prefix()
      this.get_provinces()
      this.get_user_addresses()
     this.request_data = JSON.parse(localStorage.getItem('request_data'))
      console.log("request_dataaaaa ",this.request_data);
      mapboxgl.accessToken = this.accessToken

      mapboxgl.setRTLTextPlugin(
        'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
        null,
        true // Lazy load the plugin
      )
    },
    watch: {
      selected_province: function () {
        this.get_cities()
      },
      selected_city: function () {
        this.get_areas()
        this.selected_area = 0
        this.area_search_text = ''
        this.filtered_area_items = []
      },
      selected_address: function () {
        if (this.selected_province > 0) {
          this.addressInfo = null
          this.get_address_info()
        }
      }
    },
    methods: {
      open_map () {
        var self = this
        // init the map
        this.dialog_location = true
        setTimeout(function () {
          self.map = new mapboxgl.Map({
            container: 'map2',
            style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
            center: [51.37734351262877, 35.697451890638886],
            zoom: 14 // starting zoom
          })
          self.map_function()
        }, 1000)
      },
      map_function () {
        var self = this
        if (self.user_location_lat != null && self.user_location_lat != 0) {
          self.marker = new mapboxgl.Marker({
            draggable: true
          }).setLngLat([self.user_location_lng, self.user_location_lat])
            .addTo(self.map)
        }
        self.map.on('click', function (e) {

            if (self.marker != null) {
              self.marker.remove()
            }
            self.marker = new mapboxgl.Marker({
              draggable: true
            }).setLngLat(e.lngLat)
              .addTo(self.map)
            self.user_location_lat = e.lngLat.lat
            self.user_location_lng = e.lngLat.lng


          self.marker.on('dragend', self.onDragEnd)
          self.marker.on('dragstart', self.onDragStart)
          console.log('A click event has occurred at ' + e.lngLat)
        })

        self.map.on('load', function () {
        })
      },
      onDragEnd () {
        // var lngLat = marker.getLngLat();
        this.user_location_lat = this.marker.getLngLat().lat
        this.user_location_lng = this.marker.getLngLat().lng
      },

      onDragStart () {
        // var lngLat = marker.getLngLat();
        console.log('drag started')
        this.user_location_lat = this.marker.getLngLat().lat
        this.user_location_lng = this.marker.getLngLat().lng
      },
      getCurrentLocation() {
        var self = this
        if (!navigator.geolocation) {
          bus.$emit('show_toast', [2000, 'مرورگر شما از موقعیت‌یابی پشتیبانی نمی‌کند'])
          return
        }
        
        bus.$emit('show_toast', [1500, 'در حال دریافت موقعیت...'])
        
        navigator.geolocation.getCurrentPosition(
          function(position) {
            const lat = position.coords.latitude
            const lng = position.coords.longitude
            
            // Update user location
            self.user_location_lat = lat
            self.user_location_lng = lng
            
            // Move map to current location
            if (self.map) {
              self.map.flyTo({
                center: [lng, lat],
                zoom: 16,
                duration: 1500
              })
              
              // Remove existing marker if any
              if (self.marker != null) {
                self.marker.remove()
              }
              
              // Add marker at current location
              self.marker = new mapboxgl.Marker({
                draggable: true,
                color: '#14b8a6' // teal color
              })
                .setLngLat([lng, lat])
                .addTo(self.map)
              
              // Add event listeners for dragging
              self.marker.on('dragend', self.onDragEnd)
              self.marker.on('dragstart', self.onDragStart)
              
              bus.$emit('show_toast', [2000, 'موقعیت فعلی نمایش داده شد'])
            }
          },
          function(error) {
            let errorMessage = 'خطا در دریافت موقعیت'
            switch(error.code) {
              case error.PERMISSION_DENIED:
                errorMessage = 'دسترسی به موقعیت رد شد. لطفاً مجوز را در تنظیمات مرورگر فعال کنید'
                break
              case error.POSITION_UNAVAILABLE:
                errorMessage = 'اطلاعات موقعیت در دسترس نیست'
                break
              case error.TIMEOUT:
                errorMessage = 'زمان دریافت موقعیت به پایان رسید'
                break
            }
            bus.$emit('show_toast', [3000, errorMessage])
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
          }
        )
      },
      get_user_addresses () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          ReqId: this.$route.params.rec_id,
          isFinalize: '1',
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetLastAddressByReqId', send_data, {})
          .then(response => {
            this.user_addresses = response.data.address
            response.data.address.forEach(function (number) {
              var obj = { value: number.AddressId, label: number.AddressText }
              self.address_items.push(obj)
            })
            var obj = { value: -1, label: self.$t('newAddress') }
            self.address_items.push(obj)
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_address_info () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          RequestId: this.$route.params.rec_id,
          AddressId: this.selected_address,

        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetAddressById', send_data, {})
          .then(response => {
            self.user_addresses = response.data.addressInfo
            self.customer_address = response.data.addressInfo.AddressText
            self.selected_province = parseInt(response.data.addressInfo.ProvinceId)
            self.selected_city = response.data.addressInfo.CityId
            self.selected_area = response.data.addressInfo.AreaId
            self.customer_phone = response.data.addressInfo.PhoneNo
            self.selected_phone_code = parseInt(response.data.addressInfo.PhoneCode)
            self.user_location_lat = response.data.addressInfo.Lat
            self.user_location_lng = response.data.addressInfo.Lng

            // response.data.address.forEach(function (number) {
            //
            //   var obj = {value: number.AddressId, label: number.AddressText}
            //   self.address_items.push(obj);
            // });
            // var obj = {value: -1, label: "آدرس جدید"}
            // self.address_items.push(obj);
          }).catch(e => {
          this.errors.push(e)
        })
      },
      save () {
        if (this.selected_city == 0) {
          bus.$emit('show_toast', [1500, this.$t('selectCity')])
          return false
        }
        if (this.customer_address == '') {
          bus.$emit('show_toast', [1500, this.$t('insertAddress')])
          return false
        }

        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        if (passing_data.on_site_service == false && this.user_location_lat == 0) {
          bus.$emit('show_toast', [1500, this.$t('addMapLocation')])
          return false
        }
        if (this.customer_phone == 0) {
          bus.$emit('show_toast', [1500, this.$t('insertPhoneNO')])
        return false
        }

        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

var last_address_id = 0
if (this.selected_address > 0) {
  last_address_id = this.selected_address
}

        const send_data = {
          UserId: user_id,
          ReqAddrId: 0,
          AddressText: this.customer_address,
          RequestId: this.$route.params.rec_id,
          ProvinceId: this.selected_province,
          CityId: this.selected_city,
          LastAddressId: last_address_id,
          IsFinalize: 1,
          PhoneNo: this.customer_phone,
          PhoneCode: this.selected_phone_code,
          FromTimeId: '0',
          ToTimeID: '0',
          AreaId: this.selected_area,
          Lat: this.user_location_lat,
          Lng: this.user_location_lng,
        }
console.log('json  send ' + JSON.stringify(send_data))
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddReqAddress', send_data, {})
          .then(response => {
           if (response.data.error == 0) {
             localStorage.setItem('request_data', JSON.stringify({}))

             self.$router.push({ name: 'home', params: {} })
           } else {
             bus.$emit('show_toast', [1500, self.$t('errorInsertAddress')])
           }
          }).catch(e => {
          // this.errors.push(e);

        })
      },

      get_phone_prefix () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPhonePrefixList', send_data, {})
          .then(response => {
            response.data.forEach(function (number) {
              var obj = { value: number.Id, label: number.Code }
              self.phone_code_items.push(obj)
            })
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_provinces () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetProvincies', send_data, {})
          .then(response => {
            response.data.forEach(function (number) {
              if (number.ProvinceName == self.$t('selectedAddressCityCurrent') && self.selected_province == 0) {
                self.selected_province = parseInt(number.ProvinceId)
              }
              var obj = { value: parseInt(number.ProvinceId), label: number.ProvinceName }
              self.province_items.push(obj)
            })
          }).catch(e => {
          // this.errors.push(e);

        })
      },
      get_cities () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          PId: this.selected_province,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetCitiesByProvinceId', send_data, {})
          .then(response => {
            self.city_items = []
            response.data.cities.forEach(function (number) {
              if (number.CityName == self.$t('selectedAddressCityCurrent') && self.selected_city == 0) {
                self.selected_city = parseInt(number.CityId)
              }

              var obj = { value: parseInt(number.CityId), label: number.CityName }
              self.city_items.push(obj)
            })
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_areas () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          CId: this.selected_city,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetAreas', send_data, {})
          .then(response => {
            self.area_items = []
            response.data.areas.forEach(function (number) {
              var obj = { value: parseInt(number.AreaRelId), label: number.AreaTitle }
              self.area_items.push(obj)
            })
            // Initialize filtered items with all areas
            self.filtered_area_items = [...self.area_items]
          }).catch(e => {
          this.errors.push(e)
        })
      },
      toggleAreaDropdown() {
        this.show_area_dropdown = !this.show_area_dropdown
        if (this.show_area_dropdown) {
          // Reset filter when opening
          this.area_search_text = ''
          this.filtered_area_items = [...this.area_items]
          // Focus search input after a short delay
          this.$nextTick(() => {
            const searchInput = this.$el.querySelector('.relative input[type="text"]')
            if (searchInput) {
              searchInput.focus()
            }
          })
        }
      },
      closeAreaDropdown() {
        this.show_area_dropdown = false
        this.area_search_text = ''
      },
      filterAreaItems() {
        const searchTerm = this.area_search_text.toLowerCase().trim()
        if (!searchTerm) {
          this.filtered_area_items = [...this.area_items]
        } else {
          this.filtered_area_items = this.area_items.filter(area => 
            area.label.toLowerCase().includes(searchTerm)
          )
        }
      },
      selectArea(value) {
        this.selected_area = value
        this.show_area_dropdown = false
        this.area_search_text = ''
        this.filtered_area_items = [...this.area_items]
      },
      getSelectedAreaLabel() {
        const area = this.area_items.find(a => a.value == this.selected_area)
        return area ? area.label : 'انتخاب منطقه'
      },

    }
  }
</script>

<style lang="scss" scoped>
  .basemap {
    width: 100%;
    height: 100%;
  }
  
  /* Modal Animation */
  .modal-enter-active {
    transition: opacity 0.2s ease;
  }
  
  .modal-leave-active {
    transition: opacity 0.15s ease;
  }
  
  .modal-enter, .modal-leave-to {
    opacity: 0;
  }

</style>
